__turbopack_context__.v({
  "addButton": "IndiaPlanCard-module__zkovBq__addButton",
  "bottomContainer": "IndiaPlanCard-module__zkovBq__bottomContainer",
  "bulletSeparator": "IndiaPlanCard-module__zkovBq__bulletSeparator",
  "cardContainer": "IndiaPlanCard-module__zkovBq__cardContainer",
  "cardFadeIn": "IndiaPlanCard-module__zkovBq__cardFadeIn",
  "cardHeader": "IndiaPlanCard-module__zkovBq__cardHeader",
  "chevronButton": "IndiaPlanCard-module__zkovBq__chevronButton",
  "currentPrice": "IndiaPlanCard-module__zkovBq__currentPrice",
  "descriptionList": "IndiaPlanCard-module__zkovBq__descriptionList",
  "genderInfoContainer": "IndiaPlanCard-module__zkovBq__genderInfoContainer",
  "genderText": "IndiaPlanCard-module__zkovBq__genderText",
  "infoContainer": "IndiaPlanCard-module__zkovBq__infoContainer",
  "learnMoreLink": "IndiaPlanCard-module__zkovBq__learnMoreLink",
  "middleContainer": "IndiaPlanCard-module__zkovBq__middleContainer",
  "originalPrice": "IndiaPlanCard-module__zkovBq__originalPrice",
  "planNameText": "IndiaPlanCard-module__zkovBq__planNameText",
  "plusIcon": "IndiaPlanCard-module__zkovBq__plusIcon",
  "priceContainer": "IndiaPlanCard-module__zkovBq__priceContainer",
  "priceSection": "IndiaPlanCard-module__zkovBq__priceSection",
  "testsCount": "IndiaPlanCard-module__zkovBq__testsCount",
  "thumbnailContainer": "IndiaPlanCard-module__zkovBq__thumbnailContainer",
});
